import { DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC } from './constants'

export const saveDontShowReIntegration = () => ({
  type: DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC.INITIATE,
})
export const saveDontShowReIntegrationSuccess = () => ({
  type: DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC.SUCCESS,
})
export const saveDontShowReIntegrationError = (error) => ({
  type: DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC.ERROR,
  error,
})

export default {
  // to props
  saveDontShowReIntegration,
  saveDontShowReIntegrationSuccess,
}
